var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "popper",
    {
      attrs: {
        trigger: "clickToOpen",
        options: {
          placement: "right",
          modifiers: { offset: { offset: "0,10px" } }
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip:right",
              value: _vm.text,
              expression: "text",
              arg: "right"
            }
          ],
          staticClass: "popper tooltip-inner"
        },
        [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "help-trigger",
          staticStyle: { cursor: "pointer" },
          attrs: { slot: "reference" },
          slot: "reference"
        },
        [
          _c("i", { staticClass: "material-icons themed-icon" }, [
            _vm._v("help_outline")
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24745670", { render: render, staticRenderFns: staticRenderFns })
  }
}